export enum CustomFieldDuplicateError {
	NAME = 'nameDuplicate',
	NOTIFICATION_HEADER = 'headerDuplicate',
	NOTIFICATION_TEXT = 'textDuplicate',
}
